{
  "staticPageWidgetSettings": "Static Page Widget Settings",
  "addWidget": "Add Widget",
  "editWidget": "Edit Widget",
  "addTab": "Add Tab",
  "editTab": "Edit Tab",
  "ruleGroupError": "Please fill in all fields for the rules.",
  "editCode": "Edit Code",
  "copy": "Copy Page Configuration",
  "archive": "Archive",
  "paste": "Paste Page Configuration",
  "pageTypeMismatch": "Page type does not match",
  "pageUpdated": "Page updated",
  "pageConfigIssues": "Page updated, but has warnings",
  "characterLimit": "Character limit of 50",
  "goalWorkflowNotFound": "The goal workflow on the {{widgetType}} widget, in tab '{{tab}}' was not found in this organization, it has been removed from the configuration.",
  "householdWorkflowNotFound": "The household workflow on the {{widgetType}} widget, in tab '{{tab}}' was not found in this organization, it has been removed from the configuration.",
  "customFieldNotFound": "The custom field '{{customField}}' on the {{widgetType}} widget, in tab '{{tab}}' was not found in this organization, it has been removed from the configuration.",
  "pasteWarning": "As a beta feature, pasting in page configurations may cause issues. Please use with caution and test first in a safe environment.",
  "addLinkTab": {
    "switch": "Enable link",
    "label": "External Link",
    "error": "Invalid URL"
  },
  "addWorkflowTab": {
    "switch": "Enable workflow",
    "label": "Workflow",
    "none": "None"
  },
  "editPage": {
    "button": "Edit",
    "title": "Edit Page",
    "options": {
      "greeting": "Greeting",
      "enableAddingAccountToHousehold": "Enable adding account to and from a household",
      "enableAddingGoalToHousehold": "Enable adding goal to and from a household",
      "addContent": "Add content",
      "showUpcomingMaintenanceSchedule": "Show upcoming maintenance schedule",
      "contentDescriptionBanner": "Content description banner (max. 50 characters)",
      "contentDescriptionBannerError": "Description should be less than 50 characters",
      "contentDescriptionTitle": "Content description title",
      "contentDescription": "Content description",
      "deposit": "Deposit",
      "withdraw": "Withdraw",
      "canEditHouseholdName": "Can edit household name",
      "enableClosingHousehold": "Enable closing a household",
      "canCloseGoal": "Can close goal",
      "canCloseSubAccount": "Can close sub account",
      "canCloseAccount": "Enable closing account",
      "canForceOpenAccount": "Enable force opening account",
      "canViewAccountStateHistory": "View account state history",
      "enableAccountEditing": "Enable account editing",
      "nickName": "Nickname",
      "repCode": "Rep code",
      "state": "Account status",
      "custodianAccountNumber": "Account number",
      "dealerCode": "Dealer code",
      "dealerName": "Dealer name",
      "dealerAccountNumber": "Dealer account number",
      "canTriggerWorkflows": "Can trigger workflows",
      "canChangeOrganization": "Can change organization",
      "canChangeHousehold": "Can change household",
      "removeFromHousehold": "Remove from household",
      "addToHousehold": "Add to household",
      "canFreezeClient": "Can freeze client",
      "canDeactivateClient": "Can deactivate client",
      "displayOrganizationName": "Display organization name",
      "maxPageWidth": "Max page width",
      "enableSubAccountEditing": "Enable sub-account editing",
      "goal": "Goal",
      "portfolioTheme": "Portfolio theme",
      "modelPortfolio": "Model portfolio",
      "tradingProcess": "Trading process",
      "subAccountState": "Sub-account status",
      "requireInvestorPolicyStatement": "Require investor policy statement",
      "allowFractionalShares": "Allow fractional shares",
      "allowClientDeposits": "Allow client deposits",
      "subAccountLiquidated": "Sub-account liquidated",
      "enableAccountGroupEditing": "Enable account group editing",
      "canDeleteAccountGroup": "Can delete account group",
      "defaultDepositWorkflow": {
        "label": "-"
      }
    }
  },
  "widgetType": "Type",
  "add": "Add",
  "update": "Update",
  "save": "Save",
  "hidden": "Hidden",
  "saveSuccessMessage": "Page configuration saved",
  "untitled": "Untitled",
  "saveStaticPageWidgetSuccessMessage": "Static page widget configuration saved",
  "label": "Tab label",
  "icon": "Icon",
  "listOfIcons": "List of icons",
  "deleteTab": "Delete Tab",
  "viewFor": "View for",
  "pageName": "Page Name",
  "noReports": "There are no reports available for the selected time period.",
  "selectViewFor": "Select a client to preview this page configuration",
  "deposit": "Deposit",
  "withdraw": "Withdraw",
  "options": "Options",
  "notEditableMessage": "To make changes, please contact support.",
  "feeWidgetOrgAccountGroupOnly": "Fee details are only available for organization account groups. Select an organization account group to preview this widget.",
  "widgetTypes": {
    "CLIENT_NAME": "Client Name",
    "MARKET_VALUE_CHART": "Market Value Chart",
    "ACCOUNTS": "Accounts",
    "GOALS": "Goals",
    "GOALS_AND_ACCOUNTS": "Goals and Accounts",
    "SUB_ACCOUNTS": "Sub Accounts",
    "HOLDINGS": "Holdings",
    "DOCUMENTS": "Documents",
    "LEDGER": "Ledger",
    "INITIATE_TRANSFER": "Initiate Transfer",
    "SCHEDULED_TRANSFERS": "Scheduled Transfers",
    "UPCOMING_TRANSACTIONS": "Upcoming Transactions",
    "NON_INDIVIDUAL_INFORMATION": "Non-individual Information",
    "PERSONAL_INFORMATION": "Personal Information",
    "RELATIONSHIP_INFORMATION": "Relationship Information",
    "EMPLOYMENT_INFORMATION": "Employment Information",
    "RESIDENCY_INFORMATION": "Residency Information",
    "PERSONS_OF_INTEREST": "Persons of Interest",
    "INCOME_ASSETS_AND_DEBTS": "Income, Assets and Debts",
    "SUITABILITY": "Suitability",
    "GOAL_SUITABILITY": "Goal Suitability",
    "ID_VERIFICATION": "ID Verification",
    "NEWS_AND_INSIGHTS": "News and Insights",
    "RECENT_TRANSACTIONS": "Recent Transactions",
    "EDIT_ACCOUNT": "Edit Account",
    "REFINITIV": "Refinitiv",
    "ACCESS": "Grant Access",
    "SEARCH_SECURITIES": "Search Securities",
    "ADVISOR_CONTACT_INFORMATION": "Advisor Contact Information",
    "PROJECTED_INCOME_REPORT": "Projected Income",
    "NOTES": "Notes",
    "AUDIT_LOG": "Audit Log",
    "TRADE_ORDERS": "Trade Orders",
    "FEE_DETAILS": "Fee Details",
    "HOUSE_HOLD_MEMBERS": "Members",
    "REVIEW_BANK_ACCOUNT_INFORMATION": "Review Bank Account Information",
    "COMPLIANCE": "Compliance",
    "PORTFOLIO": "Portfolio",
    "HOUSEHOLD_MODEL_PORTFOLIO": "Household Model Portfolio",
    "TRANSFERS": "Transfers",
    "RELATIONSHIPS": "Relationships",
    "ACCOUNT_GROUPS": "Account Groups",
    "FREE_FORM_INPUT": "Freeform Input",
    "RATE_OF_RETURNS": "Rate of Returns",
    "MODEL_PORTFOLIO_HOLDINGS": "Model Portfolio Holdings",
    "BULK_TRADE_REQUESTS": "Bulk Trade Requests",
    "GOAL_INFORMATION": "Goal Information",
    "NEXT_BEST_ACTION": "Next Best Action (Beta)",
    "CUSTOM_FIELDS_DISPLAY": "Custom Fields Display",
    "MARKET_DATA_TICKER": "Market Data Ticker",
    "NET_WORTH": "Net Worth (Beta)",
    "FEES_AND_REVENUE": "Fees and Revenue",
    "AUM_EXPLORER": "AUM Explorer",
    "PRODUCT_AUM_EXPOSURE": "Product AUM Exposure",
    "PRACTICE_OVERVIEW": "Practice Overview",
    "QUICK_LINKS": "Quick Links",
    "NETFLOWS": "Netflows",
    "OPEN_WORKFLOWS": "Open Workflows",
    "PENDING_TRANSACTIONS": "Pending Transactions",
    "REPORT": "Report",
    "DATA_WIDGET": "Data Widget",
    "CONFIGURABLE_TABLE_WIDGET": "Configurable Table Widget"
  },
  "refinitiv": {
    "securityDetails": "Security Details",
    "newsHeadlines": "News Headlines",
    "estimatesRatios": "Estimates & Ratios",
    "fundAllocation": "Fund Allocation",
    "fundAverageAnnualReturns": "Fund Average Annual Returns",
    "fundObjective": "Fund Objective",
    "priceYield": "Price Yield"
  },
  "error": {
    "invalidIconErrorText": "Please enter a snake_case value, e.g. \"account_balance\"",
    "maxLengthError": "Must be {{max}} characters or fewer"
  },
  "editClient": {
    "changeOrganization": "Change Organization",
    "changeHousehold": "Change Household",
    "removeFromHousehold": "Remove from Household",
    "activateClient": "Activate Client",
    "freezeClient": "Freeze Client",
    "deactivateClient": "Deactivate Client",
    "copyID": "Copy ID",
    "freezeClientModal": {
      "title": "Freeze Client",
      "bodyText": "Are you sure you want to freeze this client?"
    },
    "deactivateClientModal": {
      "title": "Deactivate Client",
      "bodyText": "Are you sure you want to deactivate this client?"
    },
    "reactivateClientModal": {
      "title": "Reactivate Client",
      "bodyText": "Are you sure you want to reactivate this client?"
    }
  },
  "editAccount": {
    "closeAccount": "Close Account",
    "forceOpenAccount": "Force Open Account",
    "viewStateHistory": "View State History"
  },
  "htmlTemplate": {},
  "rateOfReturns": {
    "portfolio": "Portfolio",
    "total": "Total",
    "groupOn": {
      "user": "User",
      "household": "Household",
      "account": "Account",
      "goal": "Goal",
      "subAccount": "Sub-account",
      "accountGroup": "Account Group"
    },
    "frequency": {
      "oneMonth": "1 Month",
      "threeMonth": "3 Months",
      "sixMonth": "6 Months",
      "oneYear": "1 Year",
      "threeYear": "3 Years",
      "fiveYear": "5 Years",
      "yearToDate": "YTD",
      "sinceInception": "Since Inception"
    }
  },
  "nextBestAction": {
    "mainTitle": "Next Best Actions",
    "title": "Generate Next Best Actions",
    "description": "Using AI and Machine Learning, we can generate a list of actions that we think will help you serve your clients better.",
    "generate": "Generate",
    "regenerate": "Regenerate",
    "disclaimerTitle": "Disclaimer",
    "disclaimer": "This is a beta feature and is not intended for production use. The generated actions are not guaranteed to be accurate or complete."
  },
  "archivePageModal": {
    "title": "Archive {{pageName}}?",
    "bodyText": "This page configuration will be archived. Do you want to proceed?"
  }
}
